export const stats = [
  { number: '15+', label: 'YEARS EXPERIENCE' },
  { number: '10', label: 'TEAM MEMBERS LED' },
  { number: '3', label: 'MAJOR COMPANIES' },
  { number: 'Always', label: 'LEARNING & ADAPTING' },
];

export const experience = [
  {
    period: '2023–Present',
    role: 'Director of Development, SFCC',
    company: 'Camping World',
    highlights: [
      'Directed development across multiple Salesforce Commerce Cloud storefronts',
      'Built and led a high-performing development team of ten',
      'Established engineering standards and structured code review practices',
      'Architected multi-system integrations bridging legacy systems with modern platforms'
    ]
  },
  {
    period: '2018–2020',
    role: 'Lead Developer',
    company: "Carter's",
    highlights: [
      'Architected scalable backend solutions for complex SFCC features',
      'Led maintenance for multiple domestic and international storefronts',
      'Served as SFCC technical subject matter expert',
      'Collaborated with stakeholders to translate business requirements'
    ]
  },
  {
    period: '2015–2018',
    role: 'Solutions Architect',
    company: 'Moku Collective',
    highlights: [
      'Led development team operations and workload distribution',
      'Served as technical lead between clients and platform teams',
      'Developed technical requirements for complex SFCC implementations',
      'Provided escalation support to ensure site stability'
    ]
  }
];

export const education = {
  degree: 'Bachelor of Science in Computer Science',
  school: 'Southern Polytechnic State University',
  year: '2005'
};

export const skills = [
  { name: 'Technical Vision & Strategy', percentage: 22 },
  { name: 'Empowering Team Autonomy', percentage: 20 },
  { name: 'Mentoring with Kindness', percentage: 18 },
  { name: 'Creating Psychological Safety', percentage: 15 },
  { name: 'Innovation & Problem Solving', percentage: 12 },
  { name: 'Process & Standards', percentage: 8 },
  { name: 'Stakeholder Communication', percentage: 5 },
];

export const technicalSkills = {
  development: ['Salesforce Commerce Cloud (SFCC)', 'JavaScript', 'React', 'NextJS', 'Node.js', 'HTML', 'CSS', 'Sass/SCSS', 'Python'],
  tools: ['Git', 'VS Code', 'JIRA', 'Confluence', 'Figma', 'Google Analytics', 'Postman', 'BrowserStack'],
  platforms: ['Vercel', 'Redis', 'GraphQL', 'GitHub', 'Bitbucket']
};

export const certifications = [
  'Salesforce Commerce Cloud (SFCC) Certified Developer'
];

// Legacy export for backward compatibility
export const resumeItems = experience.map(exp => ({
  period: exp.period,
  role: exp.role,
  company: exp.company
}));

export const contactInfo = [
  { type: 'email', icon: 'fa-at', label: 'Email', value: 'me@zachbiles.com', href: 'mailto:me@zachbiles.com' },
  { type: 'linkedin', icon: 'fa-linkedin', label: 'LinkedIn', value: 'linkedin.com/in/zachbiles', href: 'https://linkedin.com/in/zachbiles' },
  { type: 'github', icon: 'fa-github', label: 'GitHub', value: 'github.com/zbiles', href: 'https://github.com/zbiles' },
];